import { useTranslation } from 'react-i18next';
import type { PnrSource } from '@/lib/disruptions/types';
import { SourceBadge } from './source-badge';

// «Sintético» beside a PNR that is in a case. Owner, 2026-10-29: when a PNR is synthetic the
// screen says so. It sits beside the locator on the screens that list or detail a roster row
// (`DisruptionPnrGroupRow`) as such: the disruption roster and the case's passengers tab (the
// shared PnrRow), the PNR's own card (StatusHero), Operar's PNR list, «Te necesitan» and the
// meals pick list, the hotel / care / transport desk queues and their resolve panels, the care
// counter search, Express's PNR list and the dashboard search. A dialog title or a printed
// sheet opened from a marked PNR does not repeat it, and a list built from another read model
// (the hotel occupancy board, the transport journeys, a benefit override's results, a run's
// progress feed, the wallet's card rows) carries no `pnrSource` yet, so it says nothing.
// Same `SourceBadge` (label, violet tone) as the intake picker and the «Agregar PNRs» dialog,
// so generated data reads the same everywhere and never as the airline's.
//
// Only a generated PNR is marked: the airline's and a file's are the normal case and stay
// quiet, and a PNR whose source is unknown (absent — an older case, a typed locator) says
// nothing rather than something it does not know.

export function PnrSourceMark({
  source,
  className,
  testId = 'pnr-source',
}: {
  source: PnrSource | undefined;
  className?: string;
  testId?: string;
}) {
  const { t } = useTranslation('pnr');
  if (source !== 'SYNTHETIC') return null;
  return (
    <SourceBadge
      source="SYNTHETIC"
      title={t('source.syntheticHint')}
      {...(className ? { className } : {})}
      testId={testId}
    />
  );
}
